import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ResourcesTab() {
  return (
    <div className="space-y-6">
      {/* Documentation Links */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5" />
            Complete Documentation
          </CardTitle>
          <CardDescription>In-depth guides and references</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-3 md:grid-cols-3">
            <a
              href="https://bitbucket.org/projectassistant/localdocs-hosted/src/main/docs/USER_GUIDE.md"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <Button variant="outline" className="w-full justify-between">
                <span className="flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  User Guide
                </span>
                <ExternalLink className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Button>
            </a>
            <a
              href="https://bitbucket.org/projectassistant/localdocs-hosted/src/main/docs/QUICK_REFERENCE.md"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <Button variant="outline" className="w-full justify-between">
                <span className="flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Quick Reference
                </span>
                <ExternalLink className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Button>
            </a>
            <a
              href="https://bitbucket.org/projectassistant/localdocs-hosted/src/main/docs/TEAM_ONBOARDING.md"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <Button variant="outline" className="w-full justify-between">
                <span className="flex items-center gap-2">
                  <FileText className="h-4 w-4" />
                  Team Onboarding
                </span>
                <ExternalLink className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity" />
              </Button>
            </a>
          </div>
        </CardContent>
      </Card>

      {/* Support */}
      <Card>
        <CardHeader>
          <CardTitle>Need Help?</CardTitle>
          <CardDescription>Get support from the team</CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <p className="text-sm">
            <strong>Team Chat:</strong> Ask questions in team Slack/Discord
          </p>
          <p className="text-sm">
            <strong>Contact:</strong> anthonys@projectassistant.org
          </p>
          <p className="text-sm">
            <strong>Report Issues:</strong> Check browser console (F12) and report in team chat
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
